import Environment from '@utilities/environment';

import { SubscriptionStoreAddress, SubscriptionStoreUser } from '../store.types';

interface NewsletterFormAreaInfo {
    areaProjectId: string;
    areaProjectName: string;
    districtId?: string;
}

interface NewsletterFormBuyerInfo {
    intendedUsage?: string;
    purchaseTimeframe?: string;
    financialCheck?: string;
    comment?: string;
}

interface AreaNewsletterModel {
    ProjectId?: string | null;
    AreaId?: string | null;
    DistrictId?: string | null;
    PropertyId?: string | null;
    ConstructionNumberId?: string | null;
    FirstName?: string | null;
    LastNamePrefix?: string | null;
    LastName?: string | null;
    Street?: string | null;
    HouseNumber?: string | null;
    HouseNumberAddition?: string | null;
    PostalCode?: string | null;
    City?: string | null;
    Email: string;
    Phone?: string | null;
    PhoneNumber?: string | null;
    MobilePhone?: string | null;
    IsMale?: boolean | null;
    Country?: string | null;
    ReferringUrl?: string | null;
    BrochureId?: string | null;
    Comment?: string | null;
    LeadSource?: string | null;
    IntendedUsage?: string | null;
    PurchaseTimeframe?: string | null;
    FinancialCheck?: string | null;
    Website?: string | null;
}

const API_ENDPOINT = '/umbraco/api/ajaxform/submitfooterform';

const areaNewsletterBaseApiCall = async ({
    areaInfo,
    userInfo,
    address,
    buyerInfo,
}: {
    areaInfo: {
        projectPhaseId?: string;
        propertyTypeId?: string;
        areaProjectId?: string;
        areaProjectName?: string;
        districtId?: string;
        constructionNumberId?: string;
    };
    userInfo: SubscriptionStoreUser;
    address?: SubscriptionStoreAddress;
    buyerInfo?: NewsletterFormBuyerInfo;
}) => {
    const body: AreaNewsletterModel = {
        FirstName: userInfo.firstName || '',
        LastName: userInfo.lastName,
        LastNamePrefix: userInfo.lastNamePrefix || '',
        Email: userInfo.email,
        Website: userInfo.website || '',
        ProjectId: areaInfo.projectPhaseId || '',
        PropertyId: areaInfo.propertyTypeId || '',
        AreaId: areaInfo.areaProjectId || '',
        DistrictId: areaInfo.districtId || '',
        ConstructionNumberId: areaInfo.constructionNumberId || '',
    };

    if (userInfo.gender) body.IsMale = userInfo.gender === 'Mr';

    if (address) {
        body.Phone = address.phoneNumber;
        body.PostalCode = address.zipcode || '';
        body.Street = address.street || '';
        body.HouseNumber = address.houseNumber;
        body.HouseNumberAddition = address.houseNumberAddition || '';
        body.City = address.city;
        body.Country = address.country;
    }

    if (buyerInfo) {
        body.IntendedUsage = buyerInfo.intendedUsage;
        body.PurchaseTimeframe = buyerInfo.purchaseTimeframe;
        body.FinancialCheck = buyerInfo.financialCheck;
        body.Comment = buyerInfo.comment;
    }

    if (Environment.isLocal) {
        console.log(body);
    }

    await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });
};

export { areaNewsletterBaseApiCall, NewsletterFormAreaInfo, NewsletterFormBuyerInfo };
